import type { IconSvgObject } from './types';

const BridgeIcon: IconSvgObject = [
  ["path", { d: "M2 8C2.5 8 5 7.5 6 6C7 7.5 9 9 12 9C15 9 17 7.5 18 6C19 7.5 21.5 8 22 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 16H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 4V20M18 4V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M10 9V16M14 9V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default BridgeIcon;
